import { render, staticRenderFns } from "./admin-scenario-tab.vue?vue&type=template&id=5f8a41ac&scoped=true"
import script from "./admin-scenario-tab.vue?vue&type=script&lang=ts"
export * from "./admin-scenario-tab.vue?vue&type=script&lang=ts"
import style0 from "./admin-scenario-tab.vue?vue&type=style&index=0&id=5f8a41ac&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8a41ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f8a41ac')) {
      api.createRecord('5f8a41ac', component.options)
    } else {
      api.reload('5f8a41ac', component.options)
    }
    module.hot.accept("./admin-scenario-tab.vue?vue&type=template&id=5f8a41ac&scoped=true", function () {
      api.rerender('5f8a41ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/data-management/tabs/admin-scenario-tab.vue"
export default component.exports